var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"bg-variant":"light"}},[_c('link-prevue',{attrs:{"url":_vm.attr_copy['url-link']}}),_c('b-button',{attrs:{"block":"","variant":"primary"},on:{"click":_vm.callApi}},[_vm._v("Update Product Link")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }